<script>
import {cloneDeep} from 'lodash';
import {convertToLocaleTimeString} from "../../state/helpers";
import axios from 'axios';
import Swal from "sweetalert2";
import {timeSince} from "@/state/helpers";
import ReadMore from '@/components/ReadMore';
import Vue from "vue";
import CommentsSection from "../CommentsSection";
import VueEasyLightbox from "vue-easy-lightbox";

export default {
  name: "AgreementContent",

  components: {
    CommentsSection,
    ReadMore,
    VueEasyLightbox
  },
  props: {
    agreement: {
      type: Object,
      default: () => {
      }
    }
  },

  data() {
    return {
      localAgreement: {},
      prices: [],
      planItems: [],
      emptyPriceItem: {
        publish_date: '',
        social_network: '',
        post_type: '',
        giveaway: false,
        event: false,
        editMode: true
      },
      newPostInPlan: {},
      editPostInPlan: {},
      planItemToUpdate: {},
      userOnDemand: false,
      showLightbox: false,
      modalImageURL: '',
      showAllAttachments: false
    }
  },

  computed: {
    visibleAttachments () {
      if (this.showAllAttachments) {
        return this.localAgreement.campaign_attachments;
      } else {
        return this.localAgreement.campaign_attachments.slice(0,3);
      }
    },
    contentPreviewAvailable() {
      return this.localAgreement.content_url_preview && Object.keys(this.localAgreedPost.content_url_preview).length;
    },
    campaignDuration () {
        const dateConfig = { month: 'short', day: 'numeric'};
        const startDate = new Date(this.localAgreement.campaign_start_date).toLocaleDateString(undefined, dateConfig);
        const startYear = new Date(this.localAgreement.campaign_start_date).toLocaleDateString(undefined, {year: 'numeric'});
        const endDate = new Date(this.localAgreement.campaign_end_date).toLocaleDateString(undefined, dateConfig);
        // TODO: cover case where its not the same year for the start and the end date
      return `${startDate} - ${endDate}, ${startYear}`;
    },
    planItemIsEditing() {
      return this.planItems.some(item => item.editMode);
    },
    waitingPlanMessage() {
      return this.planItems.length === 0 ? 'You are waiting for the client to create the campaign plan.' : 'You are waiting for the client to fill out the campaign plan.'
    },
    disableInterested() {
      return !this.localAgreement.price_packages[0].total_net_price;
    },
    showWaitingPlanMessage() {
      return this.userType === 'influencer' && this.poolName === 'Negotiations' && this.availablePostOptinos.length !== 1;
    },
    apiPrefix() {
      return this.userType === 'client' ? '/client' : '';
    },
    showAcceptOffer() {
      return this.userType === 'influencer' && this.poolName === 'Offer';
    },
    showAddItemButton() {
      return this.userType === 'client' && this.availablePostOptinos.length !== 1 && (this.availablePostOptinos.length !== 1 && !this.planItems.some(item => item.editMode));
    },
    poolName() {
      if (this.localAgreement.status === 'offer') {
        return 'Offer'
      } else if (['interested', 'pending'].includes(this.localAgreement.status)) {
        return 'Negotiations'
      } else {
        return 'Done'
      }
    },
    postsOptions() {
      const options = [
        {
          text: 'Select Post',
          value: ''
        }
      ];
      this.prices.forEach(price => {
        for (let i = 0; i < price.quantity; i++) {
          options.push({
            text: `${this.capitaliseString(price.social_network)} - ${this.capitaliseString(price.post_type)}${price.giveaway ? ' - Giveaway' : ''}${price.event ? ' - Event' : ''}`,
            value: {
              social_network: price.social_network,
              post_type: price.post_type,
              giveaway: price.giveaway,
              event: price.event
            }
          })
        }
      });
      return options;
    },
    availablePostOptinos() {
      const postOptions = cloneDeep(this.postsOptions);

      // remove already used posts in plan item
      this.planItems.forEach(planItem => {
        const index = postOptions.findIndex(item => {
          return item.text === (`${this.capitaliseString(planItem.social_network)} - ${this.capitaliseString(planItem.post_type)}${planItem.giveaway ? ' - Giveaway' : ''}${planItem.event ? ' - Event' : ''}`);
        });
        if (index >= 0) {
          postOptions.splice(index, 1);
        }
      });

      // show only distinct values
      const distinctValues = [];
      postOptions.forEach(item => {
        // if there is no match push to distinctValues array
        if (!distinctValues.some(i => i.text === item.text)) {
          distinctValues.push(item);
        }
      });
      return distinctValues;
    },
    userType() {
      return this.$store.getters['user/userType'];
    }
  },

  async created() {
    this.localAgreement = cloneDeep(this.agreement);
    this.localAgreement.comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    this.planItems = this.localAgreement.agreed_posts.map(item => {
      item.publish_date = new Date(item.publish_date);
      return {...item, editMode: false}
    });
    this.localAgreement.agreed_posts.forEach(i => {
      i.publish_date = new Date(i.publish_date);
    });
    this.userOnDemand = !this.localAgreement.price_packages[0].total_net_price;
    this.mergePriceItems();
  },
  mounted() {
    this.markNotificationsAsRead();
  },
  methods: {
    closeLightbox() {
      this.showLightbox = false;
      this.modalImageURL = '';
    },
    setDateCustom (value, item) {
      item.publish_date = value;
    },
    async markNotificationsAsRead() {
      try {
        await axios.post(`/notification/campaign-agreement/${this.localAgreement._id}/read`);
        await this.$store.dispatch('notifications/getTopbarNotifications');
      } catch (e) {
        // TODO
      }
    },
    async initialiseData() {
      try {
        const {data} = await axios.get(`${this.apiPrefix}/campaign-agreement/${this.agreement._id}`);
        this.localAgreement = cloneDeep(data);
        this.localAgreement.comments.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        this.planItems = this.localAgreement.agreed_posts.map(item => ({...item, editMode: false}));
        this.mergePriceItems();
      } catch (e) {
        // TODO
      }
    },
    mergePriceItems() {
      this.prices = [];
      this.localAgreement.price_packages.forEach(pack => {
        pack.price_package_items.forEach(packPrice => {
          let currentPrice = this.prices.find(price => {
            return packPrice.giveaway === price.giveaway && packPrice.event === price.event && packPrice.social_network === price.social_network && packPrice.post_type === price.post_type;
          });

          if (currentPrice) {
            currentPrice.quantity += packPrice.quantity;
          } else {
            this.prices.push(packPrice);
          }
        });
      })
    },
    addPlanItem() {
      // deep clone with JSON parse/stringify
      this.planItems.push(JSON.parse(JSON.stringify(this.emptyPriceItem)));
    },
    editPlanItem(item) {
      this.editPostInPlan = {};
      if (!this.planItemIsEditing) {
        this.$set(item, 'editMode', true);
      }
    },
    async deletePlan() {
      // reset plan items
      this.planItems = [{...this.emptyPriceItem}];

      // delete every agreed post in agreement
      let promises = [];
      for (let i = 0; i < this.localAgreement.agreed_posts.length; i++) {
        promises.push(axios.delete(`${this.apiPrefix}/campaign-agreement/${this.localAgreement._id}/agreed-post/${this.localAgreement.agreed_posts[i]._id}`));
      }
      try {
        this.$store.commit('loader/START_LOADING');
        await Promise.all(promises);
        this.initialiseData();
      } catch {
        // TODO: handle error
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    savePlanItem(item) {
      if (item._id) {
        this.updatePlanItem(item);
      } else {
        this.createPlanItem(item);
      }
    },
    async updatePlanItem(item) {
      const planItem = {
        publish_date: item.publish_date,
        social_network: this.editPostInPlan.social_network,
        post_type: this.editPostInPlan.post_type,
        giveaway: this.editPostInPlan.giveaway,
        event: this.editPostInPlan.event
      };
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.put(`${this.apiPrefix}/campaign-agreement/${this.localAgreement._id}/agreed-post/${item._id}`, planItem);
        this.initialiseData();
        this.editPostInPlan = {}
      } catch (e) {
        // TODO
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async createPlanItem(item) {
      const planItem = {
        publish_date: item.publish_date,
        social_network: this.newPostInPlan.social_network,
        post_type: this.newPostInPlan.post_type,
        giveaway: this.newPostInPlan.giveaway,
        event: this.newPostInPlan.event
      };
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.post(`${this.apiPrefix}/campaign-agreement/${this.localAgreement._id}/agreed-post`, planItem);
        this.initialiseData();
        this.newPostInPlan = {}
      } catch (e) {
        // TODO
      } finally {
        this.$store.commit('loader/END_LOADING');
      }

      // change item mode to read
      item.editMode = false;

      // add new empty item
      this.planItems.push(JSON.parse(JSON.stringify(this.emptyPriceItem)));
    },
    cancelPlanItem(item) {
      item.editMode = false;
      // if item doesnt have id then it is not saved on server so we can remove it from the planItems on cancel
      if (!item._id) {
        this.planItems.pop();
      }
    },
    async deletePlanItem(item) {
      this.$store.commit('loader/START_LOADING');
      try {
        await axios.delete(`${this.apiPrefix}/campaign-agreement/${this.localAgreement._id}/agreed-post/${item._id}`);
        this.initialiseData();
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    capitaliseString(string) {
      return (string.charAt(0).toUpperCase() + string.slice(1)).replace(/_/g, " ");
    },
    isItemAddingDisabled (item) {
      return item.publish_date === '' || !this.newPostInPlan.social_network || !this.newPostInPlan.post_type;
    },
    isEditItemAddingDisabled (item) {
      return item.publish_date === '' || !this.editPostInPlan.social_network || !this.editPostInPlan.post_type;
    },
    convertToLocaleTimeString (date) {
      return convertToLocaleTimeString(date);
    },
    async interestedInAgreement() {
      this.$store.commit('loader/START_LOADING');

      const payload = {}
      if (this.userOnDemand) {
        payload.total_net_price = this.localAgreement.price_packages[0].total_net_price
      }

      try {
        await axios.post(`${this.apiPrefix}/campaign-agreement/${this.localAgreement._id}/interested`, payload);
        this.$emit('closeModal');

        if (this.$router.currentRoute.name !== 'offers_board') {
          await Swal.fire({
            title: "Nice!",
            text: "You can find this campaign agreement in your Offers Board .",
            icon: "success",
            confirmButtonColor: "#01baf1",
            confirmButtonText: "OK"
          });
        }
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    async cancelAgreement() {
      if (await this.confirmModal()) {
        this.$store.commit('loader/START_LOADING');
        try {
          await axios.post(`${this.apiPrefix}/campaign-agreement/${this.localAgreement._id}/cancel`);
          this.$emit('closeModal');
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    async archiveAgreement() {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: 'Back',
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#666e75",
        confirmButtonText: "Yes, archive it"
      });
      if (result.value) {
        this.$store.commit('loader/START_LOADING');
        try {
          await axios.post(`${this.apiPrefix}/campaign-agreement/${this.localAgreement._id}/archive`);
          this.$emit('closeModal');
        } finally {
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    timeAgo(time) {
      return `${timeSince(new Date(time))} ago`;
    },
    async confirmModal() {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: 'Back',
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#666e75",
        confirmButtonText: "Yes, cancel it"
      });
      return result.value;
    },
    editPostOptions(item) {
      const option = {
        text: `${this.capitaliseString(item.social_network)} - ${this.capitaliseString(item.post_type)}${item.giveaway ? ' - Giveaway' : ''}${item.event ? ' - Event' : ''}`,
        value: {
          social_network: item.social_network,
          post_type: item.post_type,
          giveaway: item.giveaway,
          event: item.event
        }
      };
      if (!this.editPostInPlan.post_type && typeof this.editPostInPlan !== 'string') {
        this.editPostInPlan = option.value;
      }
      const alreadyExists = this.availablePostOptinos.some(planItem => {
        const value = planItem.value;
        if (value) {
          return option.text === (`${this.capitaliseString(planItem.value.social_network)} - ${this.capitaliseString(planItem.value.post_type)}${planItem.value.giveaway ? ' - Giveaway' : ''}${planItem.value.event ? ' - Event' : ''}`);
        }
      });
      if (alreadyExists) {
        return this.availablePostOptinos;
      } else {
        return [...this.availablePostOptinos, option];
      }
    },
    itemKey (item) {
      return `${this.capitaliseString(item.social_network)} - ${this.capitaliseString(item.post_type)}${item.giveaway ? ' - Giveaway' : ''}${item.event ? ' - Event' : ''}`;
    },
    minDateOrToday (date) {
      const minDate = new Date(date);
      const today = new Date();
      if (minDate <= today) {
        return today;
      } else {
        return minDate;
      }
    },
    previewAttachment(attachment) {
      if (attachment.mime_type.includes('image')) {
        this.showLightbox = true;
        this.modalImageURL = attachment.url;
      } else {
        window.open(attachment.url, '_blank');
      }
    },
    async signPlan() {
      // yes/no modal
      const confirmed = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this.",
        icon: "info",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: "#01baf1",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Sign Agreement"
      });

      if (confirmed.value) {
        this.$store.commit('loader/START_LOADING');
        try {
          await axios.post(`${this.apiPrefix}/campaign-agreement/${this.localAgreement._id}/sign`);
          this.$emit('closeModal');

          this.$store.commit('loader/END_LOADING');

          Vue.swal({
            position: "top",
            icon: "success",
            title: "Great!",
            text: "We prepared posts for you on the Content Board.",
            showConfirmButton: false,
            timer: 3000
          });

        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e)
          this.$store.commit('loader/END_LOADING');
        }
      }
    }
  }
}
</script>

<template>
  <div class="agreement-modal-content">
    <div class="agreement-content">
      <div class="modal-custom-header">
        <div>
          <h4 class="mb-0"> {{ localAgreement.campaign_name }}</h4>
          <p class="mb-0 modal-subtitle text-muted">
            CAMPAIGN - in list <span class="pool-name">{{ poolName }}</span> <br>
            <span
                    class="badge badge-pill font-size-12"
                    :class=" {
                            'badge-soft-primary': `${localAgreement.status}` === 'offer',
                            'badge-warning': `${localAgreement.status}` === 'interested',
                            'badge-primary': `${localAgreement.status}` === 'pending',
                            'badge-soft-danger': `${localAgreement.status}` === 'canceled',
                            'badge-success': `${localAgreement.status}` === 'signed',
                            // add fake-class to prevent overriding same class names
                            'badge-soft-danger fake-class': `${localAgreement.status}` === 'aborted',
                            'badge-secondary': `${localAgreement.status}` === 'expired' }"
            >
                          {{ (localAgreement.status.charAt(0).toUpperCase() + localAgreement.status.slice(1)).replace(/_/g, " ") }}
                      </span>
          </p>
        </div>
        <span class="close-modal-x" @click="$emit('closeModal')"><i class="bx bx-x"></i></span>
      </div>
      <div class="row mt-3">
        <div class="col-auto">
          <div class="row" style="max-width:180px;">
            <div class="col-12 text-muted">
              {{ userType === 'influencer' ? 'CLIENT' : 'INFLUENCER' }}
            </div>
            <div class="col-12">
              <div v-if="userType === 'influencer'" class="d-flex align-items-center my-1">
                <img v-if="localAgreement.client_image" class="media-object rounded-circle avatar-xs" alt
                     :src="localAgreement.client_image"/>
                <div v-else class="media-object avatar-xs letter-in-circle">{{
                    localAgreement.client_image_alt.charAt(0)
                  }}
                </div>
                <h5 class="font-size-13 mb-0 ml-2">{{ localAgreement.client_image_alt }}</h5>
              </div>
              <router-link tag="a" :to="`/client/influencers/${localAgreement.influencer_id}`" v-else class="d-flex align-items-center my-1">
                <img v-if="localAgreement.influencer_image" class="media-object rounded-circle avatar-xs" alt
                     :src="localAgreement.influencer_image"/>
                <div v-else class="media-object avatar-xs letter-in-circle">
                  {{ localAgreement.influencer_image_alt.charAt(0) }}
                </div>
                <h5 class="font-size-13 mb-0 ml-2">{{ localAgreement.influencer_image_alt }}</h5>
              </router-link>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="row" style="max-width:180px;">
            <div class="col-12 text-muted">
              CAMPAIGN NAME
            </div>
            <div class="col-12 d-flex align-items-center" style="height:2.5rem">
              <div class="d-flex align-items-center my-1">
                <h5 class="font-size-13 mb-0">{{ localAgreement.campaign_name }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <div class="row" style="max-width:180px;">
            <div class="col-12 text-muted">
              CAMPAIGN DURATION
            </div>
            <div class="col-12 d-flex align-items-center" style="height:2.5rem">
              <div class="d-flex align-items-center my-1">
                <h5 class="font-size-13 mb-0">{{ campaignDuration }}</h5>
              </div>
            </div>
          </div>
        </div>
        <div v-if="(poolName === 'Offer' && userType === 'client') || poolName !== 'Offer'" class="col">
          <div class="row">
            <div class="col-12 text-muted text-right">
              ACTIONS
            </div>
            <div class="col-12 d-flex justify-content-end align-items-center" style="height:2.5rem">
              <button
                  v-if=" userType === 'influencer' && poolName === 'Negotiations' && availablePostOptinos.length === 1"
                  @click="signPlan" class="btn btn-primary btn-sm">
                <i class="bx bx-check-circle align-middle font-size-14 mr-1"></i>
                <span class="align-middle">Sign Agreement</span>
              </button>
              <button v-if="poolName === 'Done'" @click="archiveAgreement"
                      class="btn btn-outline-secondary btn-sm text-left ml-2">
                <i class="bx bx-trash align-middle font-size-14"></i>
                Archive
              </button>
              <button v-else-if="!showAcceptOffer" @click="cancelAgreement"
                      class="btn btn-outline-danger btn-sm text-left ml-2">
                <i class="fas fa-ban mr-1 align-middle"></i>
                <span class="align-middle">Cancel {{ poolName === 'Offer' ? 'Offer' : 'Agreement' }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="modal-section description-section">
            <b-alert
                    :show="poolName === 'Offer' && userType === 'client'"
                    class="mt-3"
                    variant="info"
                    dismissible>
              You are waiting for the influencer to accept your offer.
            </b-alert>
            <h5 class="section-heading">Campaign description</h5>
            <read-more v-if="localAgreement.campaign_description"
                       :text="localAgreement.campaign_description"></read-more>
            <div v-else class="text-muted">
              No description.
            </div>
          </div>
          <div v-if="localAgreement.offer_message && poolName === 'Offer'" class="modal-section description-section">
            <h5 class="section-heading">Offer message</h5>
            <read-more v-if="localAgreement.offer_message" :text="localAgreement.offer_message"></read-more>
            <div v-else class="text-muted">
              No message.
            </div>
          </div>
          <div class="modal-section">
            <div class="d-flex align-items-center justify-content-between section-heading">
              <h5 class="mb-0">Campaign posts</h5>
              <div v-if="userType === 'client' && localAgreement.campaign_agreement_grand_total_price" class="ml-3">
                <h5 class="mb-0"><span class="text-muted font-size-14">Price:</span> &euro;
                  {{ localAgreement.campaign_agreement_grand_total_price.toLocaleString() }}</h5>
              </div>
              <div v-else-if="userType === 'influencer' && localAgreement.campaign_agreement_net_price" class="ml-3">
                <h5 class="mb-0"><span class="text-muted font-size-14">Price:</span> &euro;
                  {{ localAgreement.campaign_agreement_net_price.toLocaleString() }}</h5>
              </div>
            </div>
            <div class="p-1 price-item pricing-header-row mb-1 d-none d-md-block">
              <div class="row align-items-center">
                <div class="col-12 col-md text-center">
                  <p class="text-muted mb-0">{{ $t('Platform') }}</p>
                </div>
                <div class="col-6 col-md">
                  <p class="text-muted mb-0">{{ $t('Post type') }}</p>
                </div>
                <div class="col-6 col-md">
                  <p class="text-muted mb-0">{{ $t('Quantity') }}</p>
                </div>
                <div v-if="userType === 'client' && poolName === 'Negotiations'" class="col-auto invisible">
                  <button class="btn btn-sm btn-outline-warning something"><i
                      class="bx bxs-edit-alt font-size-16 align-middle"></i></button>
                  <button @click="deletePlanItem(item)" class="btn btn-sm btn-outline-danger something ml-1"><i
                      class="bx bx-trash font-size-16 align-middle"></i></button>
                </div>
              </div>
            </div>
            <div class="package-container">
              <div class="p-1 price-item" v-for="(price, index) in prices"
                   :key="`${price.post_type}_${price.social_network}_${index}`">
                <div class="row align-items-center">
                  <div class="col text-center mt-2 mt-md-0">
                    <p class="text-muted d-md-none mb-1">{{ $t('Platform') }}</p>
                    <div class="social-image-container d-flex align-items-center justify-content-center">
                      <img v-if="price.social_network === 'instagram'"
                           :src="require('@/assets/images/brands/instagram.png')"
                           class="img-fluid" alt="">
                      <img v-if="price.social_network === 'facebook'"
                           :src="require('@/assets/images/brands/facebook.png')" class="img-fluid" alt="">
                      <img v-if="price.social_network === 'youtube'"
                           :src="require('@/assets/images/brands/youtube.png')" class="img-fluid" alt="">
                      <img v-if="price.social_network === 'blog'"
                           :src="require('@/assets/images/brands/analytics-logo.png')"
                           class="img-fluid" alt="">
                    </div>
                  </div>
                  <div class="col-6 order-2 order-md-2 col-md mt-2 mt-md-0">
                    <p class="text-muted d-md-none mb-1">{{ $t('Post type') }}</p>
                    <span class="mb-0"> {{ capitaliseString(price.post_type) }} </span>
                    <span v-if="price.giveaway" class="badge badge-pill badge-soft-primary font-size-12 mr-1">
                        + Giveaway
                    </span>
                    <span v-if="price.event" class="badge badge-pill badge-soft-primary font-size-12">
                        + Event
                    </span>
                  </div>
                  <div class="col-6 order-1 order-md-3 col-md mt-2 mt-md-0">
                    <p class="text-muted d-md-none mb-1">{{ $t('Quantity') }}</p>
                    <span class="mb-0"> {{ price.quantity }} </span>
                  </div>
                  <div v-if="userType === 'client' && poolName === 'Negotiations'"
                       class="col-auto invisible order-md-3">
                    <button class="btn btn-sm btn-outline-warning something"><i
                        class="bx bxs-edit-alt font-size-16 align-middle"></i></button>
                    <button @click="deletePlanItem(item)" class="btn btn-sm btn-outline-danger something ml-1"><i
                        class="bx bx-trash font-size-16 align-middle"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="showAcceptOffer">
            <div v-if="userOnDemand">
              <div class="text-center mt-3 font-size-14 mb-1">Price in &euro;:</div>
              <div class="d-flex justify-content-center">
                <b-input class="price-input" v-model.number="localAgreement.price_packages[0].total_net_price" type="text" oninput="this.value=this.value.replace(/[^0-9]/g,'');"></b-input>
              </div>
            </div>
            <div class="d-flex justify-content-center my-3">
              <button @click="cancelAgreement" class="btn btn-outline-danger text-left">
                <i class="fas fa-ban mr-1 align-middle"></i>
                Not interested
              </button>
              <button :disabled="disableInterested" @click="interestedInAgreement"
                      class="btn btn-primary text-left ml-3">
                <i class="bx bx-check-circle align-middle font-size-18 mr-1"></i>
                <span class="align-middle"> I am interested</span>
              </button>
            </div>
          </div>
          <div v-if="['Negotiations', 'Done'].includes(poolName)" class="modal-section">
            <div class="d-flex align-items-center justify-content-between section-heading">
              <h5 class="mb-0">Campaign plan</h5>
              <div v-if="userType === 'client' && poolName === 'Negotiations'" class="ml-3">
                <button v-if="planItems.length > 0" @click="deletePlan" class="btn btn-sm btn-light"><i
                    class="bx bx-trash align-middle font-size-14"></i> <span class="align-middle">Delete plan</span>
                </button>
                <button v-else @click="addPlanItem" class="btn btn-primary btn-sm"> + Create plan</button>
              </div>
            </div>
            <b-alert
                :show="userType === 'client' && poolName === 'Negotiations' && (availablePostOptinos.length === 1)"
                class="mt-3"
                variant="primary"
                dismissible>
              You scheaduled all of your posts, now you are waiting for influencer to sign the deal!
            </b-alert>
            <div v-if="planItems.length === 0" class="text-muted">
              No scheduled posts.
            </div>
            <b-alert
                :show="showWaitingPlanMessage"
                class="mt-3"
                variant="info"
                dismissible>
              {{ waitingPlanMessage }}
            </b-alert>

            <div v-if="planItems.length">
              <div class="p-1 price-item pricing-header-row mb-1 d-none d-md-block">
                <div class="row align-items-center">
                  <div class="col col-md text-center">
                    <p class="text-muted mb-0">{{ $t('Platform') }}</p>
                  </div>
                  <div class="col-6 col-md">
                    <p class="text-muted mb-0">{{ $t('Post type') }}</p>
                  </div>
                  <div class="col-12 col-md">
                    <p class="text-muted mb-0">{{ $t('Date') }}</p>
                  </div>
                  <div v-if="userType === 'client' && poolName === 'Negotiations'" class="col-auto invisible">
                    <button class="btn btn-sm btn-outline-warning something"><i
                        class="bx bxs-edit-alt font-size-16 align-middle"></i></button>
                    <button @click="deletePlanItem(item)" class="btn btn-sm btn-outline-danger something ml-1"><i
                        class="bx bx-trash font-size-16 align-middle"></i></button>
                  </div>
                </div>
              </div>
              <form @submit.prevent>
                <div v-for="item in planItems" :key="item._id" class="plan-item p-1">
                  <div v-if="item.editMode" class="row plan-item-edit align-items-center mt-1">
                    <div class="col">
                      <b-form-select v-if="item.post_type" size="sm" v-model="editPostInPlan"
                                     :options="editPostOptions(item)"></b-form-select>
                      <b-form-select v-else size="sm" v-model="newPostInPlan"
                                     :options="availablePostOptinos"></b-form-select>
                    </div>
                    <div class="col-4">
                      <b-form-datepicker size="sm" id="example-datepicker" :min="minDateOrToday(localAgreement.campaign_start_date)" :max="new Date(localAgreement.campaign_end_date)"
                                         :value="item.publish_date ? new Date(item.publish_date) : ''" @input="setDateCustom($event, item)"></b-form-datepicker>
                    </div>
                    <div class="col-12 mt-2">
                      <div>
                        <button v-if="!item.post_type" class="btn btn-sm btn-primary" :disabled="isItemAddingDisabled(item)"
                                @click="savePlanItem(item)"> Add
                        </button>
                        <button v-else class="btn btn-sm btn-primary" :disabled="isEditItemAddingDisabled(item)"
                                @click="savePlanItem(item)"> Save
                        </button>
                        <button class="btn btn-light btn-sm ml-2" @click="cancelPlanItem(item)"><i
                            class="bx bx-x font-size-18 align-middle"></i></button>
                      </div>
                    </div>
                  </div>
                  <div v-else class="row align-items-center">
                    <div class="col text-center">
                      <div class="social-image-container d-flex align-items-center justify-content-center">
                        <img v-if="item.social_network === 'instagram'"
                             :src="require('@/assets/images/brands/instagram.png')"
                             class="img-fluid" alt="">
                        <img v-if="item.social_network === 'facebook'"
                             :src="require('@/assets/images/brands/facebook.png')" class="img-fluid" alt="">
                        <img v-if="item.social_network === 'youtube'"
                             :src="require('@/assets/images/brands/youtube.png')" class="img-fluid" alt="">
                        <img v-if="item.social_network === 'blog'"
                             :src="require('@/assets/images/brands/analytics-logo.png')"
                             class="img-fluid" alt="">
                      </div>
                    </div>
                    <div class="col">
                      {{ capitaliseString(item.post_type) }}
                      <span v-if="item.giveaway" class="badge badge-pill badge-soft-primary font-size-12 mr-1">
                        + Giveaway
                      </span>
                      <span v-if="item.event" class="badge badge-pill badge-soft-primary font-size-12">
                          + Event
                      </span>
                    </div>
                    <div class="col">
                      <!--                                        <i class="bx bx-calendar-check font-size-18 align-middle"></i>-->
                      {{ convertToLocaleTimeString(item.publish_date) }}
                    </div>
                    <div v-if="userType === 'client' && poolName === 'Negotiations'" class="col-auto text-center">
                      <button @click="editPlanItem(item)" class="btn btn-sm btn-outline-warning something"><i
                          class="bx bx-edit-alt font-size-18 align-middle"></i></button>
                      <button @click="deletePlanItem(item)" class="btn btn-sm btn-outline-danger something ml-1"><i
                          class="bx bx-trash font-size-18 align-middle"></i></button>
                    </div>
                  </div>
                </div>
                <div v-if="showAddItemButton" class="d-flex">
                  <button class="btn btn-sm btn-primary mt-2" @click="addPlanItem"> + Add item</button>
                </div>
                <div v-if="userType === 'client' && poolName === 'Negotiations' && (availablePostOptinos.length === 1)"
                     class="text-muted mt-2">
                  No more posts to schedule.
                </div>
              </form>
            </div>
          </div>

          <div v-if="localAgreement.campaign_attachments.length" class="modal-section">
            <div class="d-flex align-items-center justify-content-between section-heading">
              <h5 class="mb-0">Campaign attachments</h5>
            </div>
            <div v-if="localAgreement.campaign_attachments.length">
              <div v-for="attachment in visibleAttachments" :key="attachment._id" class="post-attachment mb-2">
                <div @click="previewAttachment(attachment)" class="attachment-thumbnail has-pointer-cursor">
                  <div v-if="attachment.mime_type.includes('pdf')" class="attachment-icon">
                    <i class='bx bxs-file-pdf'></i>
                  </div>
                  <img :src="attachment.video_thumbnail || attachment.url" class="img-fluid" alt="">
                </div>
                <div class="col attachment-body">
                  <h6 class="mb-1 has-pointer-cursor">{{ attachment.name }}</h6>
                  <div v-if="!attachment.editMode" class="attachment-meta font-size-12">
                    <span class="text-muted"> Added {{ timeAgo(attachment.created_at) }}</span>
                    <span v-if="userType === 'influencer' && ['Not submitted', 'Draft'].includes(poolName)"
                          class="attachment-acitons">
                                            <span @click.stop="editAttachment(attachment)"
                                                  class="text-muted ml-2 comment-link">Edit</span>
                                            <span @click.stop="removeAttachment(attachment)"
                                                  class="text-muted ml-2 comment-link">Delete</span>
                                          </span>
                    <span class="attachment-acitons">
                      <span @click="previewAttachment(attachment)"
                            class="text-muted ml-2 comment-link">Preview</span>
                    </span>
                  </div>
                  <div v-else>
                    <a @click.stop="canceleFileEdit(attachment)" class="btn btn-sm btn-light mt-2 mr-2">Cancel</a>
                    <a @click.stop="updateFile(attachment)" class="btn btn-sm btn-primary mt-2 mr-2">Save</a>
                  </div>
                  <div class="attachment-description">

                  </div>
                </div>
              </div>
              <div v-if="localAgreement.campaign_attachments.length > 3 && !showAllAttachments"
                   class="show-more-link"
                   @click="showAllAttachments = true">
                Show {{ localAgreement.campaign_attachments.length - 3 }} more...
              </div>
              <div v-if="localAgreement.campaign_attachments.length > 3 && showAllAttachments"
                   class="show-more-link"
                   @click="showAllAttachments = false">
                Show less
              </div>
            </div>
          </div>
          <div v-if="localAgreement.campaign_links.length" class="modal-section">
            <div class="d-flex align-items-center justify-content-between section-heading">
              <h5 class="mb-0">Campaign links</h5>
            </div>
            <div v-for="link in localAgreement.campaign_links" class="campaign-link-wrap">
              {{ link.name }} <a :href="link.url" target="_blank" class="campaign-link">({{ link.url.length > 100 ? `${link.url.slice(0,99)}...` : link.url }})</a>
            </div>
          </div>

          <CommentsSection :cardData="localAgreement" card-type="campaign-agreement" @updated="initialiseData" />

        </div>
      </div>
    </div>

    <!--        lightbox for dispalying images-->
    <vue-easy-lightbox
            :visible="showLightbox"
            :imgs="modalImageURL"
            @hide="closeLightbox"
    ></vue-easy-lightbox>

  </div>
</template>

<style scoped>
.price-item {
  background-color: #fbfbfb;
  border-radius: 4px;
  border-bottom: 1px solid #f6f6f6;
  box-shadow: 0px 3px 4px 1px #efefef;
}

.tab-section h5 {
  font-size: 0.9rem;
}

.pricing-header-row {
  border-radius: 2px;
}

.social-image-container {
  height: 30px;
}

.social-image-container img {
  width: 22px;
}

textarea {
  resize: none;
}

.plan-item {
  background-color: #fbfbfb;
  border-bottom: 1px solid #f6f6f6;
  box-shadow: 0px 3px 4px 1px #efefef;
}

.plan-item:first-child {
  margin-top: 5px;
}

.plan-item:last-child {
  border-bottom: 0;
}

.modal-subtitle {
  margin-top: 5px;
  font-size: 1em;
}

.modal-custom-header {
  display: flex;
  justify-content: space-between;
}

.pool-name {
  text-decoration: underline;
}

.price-input {
  font-size: 16px;
  width: 200px;
}

.card-top-image-container {
  position: relative;
  background-color: #dce7f1;
  border-radius: 0.5rem 0.5rem 0px 0px;
  height: 220px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.agreement-content {
  padding: 1.5em;
}

.description-section {
  white-space: pre-wrap;
}

.attachment-thumbnail {
  position: relative;
  height: 80px;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #dce7f1;
}

.attachment-thumbnail img {
  max-height: 80px;
}

.comment-link {
  cursor: pointer;
  text-decoration: underline !important;
}
  .show-more-link {
    text-decoration: underline;
    color: #74788d;
    cursor: pointer;
  }

.attachment-icon {
  position: absolute;
  left: calc(50% - 25px);
  top: calc(50% - 25px);
  border-radius: 50%;
  height: 50px;
  width: 50px;
  z-index: 10;
}

.attachment-icon i {
  font-size: 50px;
  color: rgba(255, 255, 255, 0.8);
}

.campaign-link-wrap {
  margin-bottom: 0.5rem;
  line-break: anywhere;
}
.campaign-link-wrap:last-child {
  margin-bottom: 0;
}

.campaign-link-wrap a {
  color: #74788d !important;
  text-decoration: underline !important;
}
</style>
